import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../components/UI';
import { getReferredLink } from './Utils';

interface PropTypes {
  referralCode: string;
}

const EmailShareButton: React.FC<PropTypes> = ({ referralCode }) => {
  const { t } = useTranslation();

  const link = getReferredLink(referralCode);

  return (
    <a
      href={`mailto:?subject=Merlin Referral Code&body=${t('signUp.referral', {
        referralCode,
      })} ${link}`}
    >
      <Button type="button" variant="secondary" buttonClass="w-28">
        {t('referral.shareOnEmail')}
        <img
          className="flex w-4 h-4 ml-1 cursor-pointer"
          src={`/icons/social-icons/email-LIGHT.svg`}
          alt={t('referral.shareOnEmail')}
        />
      </Button>
    </a>
  );
};

export default EmailShareButton;
